"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Footer.module.css"));
function Footer(props) {
    var published = props.published, currentPage = props.currentPage, endPage = props.endPage;
    return (React.createElement("div", { className: styles.footerWrap },
        React.createElement("div", { className: styles.footerLeft },
            React.createElement("p", null, "" + published)),
        React.createElement("p", { className: styles.footerRight },
            React.createElement("span", { className: styles.footerDescription }),
            "Rev",
            " ",
            React.createElement("span", { className: styles.footerBold }, currentPage),
            ".",
            React.createElement("span", { className: styles.footerBold }, endPage))));
}
exports.default = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9Gb290ZXIvRm9vdGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSwyQ0FBOEI7QUFDOUIsMERBQTZDO0FBRTdDLFNBQXdCLE1BQU0sQ0FBQyxLQUFLO0lBQ3pCLElBQUEsMkJBQVMsRUFBRSwrQkFBVyxFQUFFLHVCQUFPLENBQVM7SUFFL0MsT0FBTyxDQUNILDZCQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsVUFBVTtRQUM3Qiw2QkFBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLFVBQVU7WUFDN0IsK0JBQUksS0FBRyxTQUFXLENBQUssQ0FDckI7UUFDTiwyQkFBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLFdBQVc7WUFDNUIsOEJBQU0sU0FBUyxFQUFFLE1BQU0sQ0FBQyxpQkFBaUIsR0FBUzs7WUFBSSxHQUFHO1lBQ3pELDhCQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsVUFBVSxJQUFHLFdBQVcsQ0FBUTs7WUFDeEQsOEJBQU0sU0FBUyxFQUFFLE1BQU0sQ0FBQyxVQUFVLElBQUcsT0FBTyxDQUFRLENBQ3BELENBQ0YsQ0FDVCxDQUFBO0FBQ0wsQ0FBQztBQWZELHlCQWVDIn0=